import { HeroSection } from './Components/HeroSection'
import { ContentSection } from './Components/ContentSection'

export const WhoWeAre = () => {
  return (
    <div>
      <HeroSection />
      <ContentSection />

    </div>
  )
}
